import React from 'react';
import {getMergeSortAnimations} from '../sortingAlgorithms/sortingAlgorithms';
import './sortingVisualizer.css';

// Change this value for the speed of animations
const ANIMATION_SPEED_MS = 3;

// Change this value for the number of bars (value) in the array.
const NUMBER_OF_ARRAY_BARS = 310;

// This is the main color of the array bars.
const PRIMARY_COLOR = 'palegreen';

// This is the color of array bars that are being compared throughout the animations.
const SECONDARY_COLOR = 'red';


export default class sortingVisualizer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            array: [],
        };
    }

    componentDidMount() { //array resets every time the component (array) mounts (loads)
        this.resetArray();
    }

    resetArray() {
        const array = [];
        for (let i = 0; i < NUMBER_OF_ARRAY_BARS; i++) {
          array.push(randomIntFromInterval(5, 730));
        }
        this.setState({array});
      }

    mergeSort() {
        const animations = getMergeSortAnimations(this.state.array);
        for (let i = 0; i < animations.length; i++) {
          const arrayBars = document.getElementsByClassName('array-bar');
          const isColorChange = i % 3 !== 2;
          if (isColorChange) {
            const [barOneIndex, barTwoIndex] = animations[i];
            const barOneStyle = arrayBars[barOneIndex].style;
            const barTwoStyle = arrayBars[barTwoIndex].style;
            const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;
            setTimeout(() => {
              barOneStyle.backgroundColor = color;
              barTwoStyle.backgroundColor = color;
            }, i * ANIMATION_SPEED_MS);
          } else {
            setTimeout(() => {
              const [barOneIndex, newHeight] = animations[i];
              const barOneStyle = arrayBars[barOneIndex].style;
              barOneStyle.height = `${newHeight}px`;
            }, i * ANIMATION_SPEED_MS);
          }
        }
      }

    quickSort() {}

    heapSort() {}

    bubbleSort() {}

    // NOTE: This method is only used during testing and will only work if your sorting algorithms actually return the sorted arrays;
    // if they return the animations (as they currently do), then this method will be broken.
    testSortingAlgorithms() {
        for (let i = 0; i < 100; i++) {
          const array = [];
          const length = randomIntFromInterval(1, 1000);
          for (let i = 0; i < length; i++) {
            array.push(randomIntFromInterval(-1000, 1000));
          }
          const javaScriptSortedArray = array.slice().sort((a, b) => a - b);
          const mergeSortedArray = getMergeSortAnimations(array.slice());
          console.log(arraysAreEqual(javaScriptSortedArray, mergeSortedArray));
        }
      }

    render() {
        const {array} = this.state;

        return (
            <div className="body">
                <div className="array-container">
                {array.map((value, index) => ( //iterating through the array and mapping each element to a div 
                //we need to add a key to each div because they are rendered in an iterable (otherwise, react would show an error in the console)
                    <div
                    className="array-bar"
                    key={index}
                    style={{height: `${value}px`}}></div>
                ))}
                </div>
                <div className="button-section">
                    <button onClick={() => this.resetArray()}>Generate New Array</button>
                    <button onClick={() => this.mergeSort()}>Merge Sort</button>
                    <button onClick={() => this.quickSort()}>Quick Sort</button>
                    <button onClick={() => this.heapSort()}>Heap Sort</button>
                    <button onClick={() => this.bubbleSort()}>Bubble Sort</button>
                    {/* <button onClick={() => this.testSortingAlgorithms()}>Test Sorting Algorithms</button> */}
                </div>
            </div>
        );
    }
}

const randomIntFromInterval = (min,max) => { //randomize a number in an interval including max and min
    return Math.floor(Math.random() * (max - min + 1) + min);
}

const arraysAreEqual = (arr1, arr2) => { //compares that the two arrays submitted are equal
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}